var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4563 14.4399C3.4563 14.8306 3.4563 22.0615 3.4563 27.0007C3.4563 28.1053 4.35173 28.9999 5.4563 28.9999H25.0352C26.1398 28.9999 27.0352 28.1045 27.0352 26.9999V14.4399",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38586 23.5203V18.8003C7.38586 18.248 7.83358 17.8003 8.38586 17.8003H22.1052C22.6574 17.8003 23.1052 18.248 23.1052 18.8003V23.5203C23.1052 24.0726 22.6574 24.5203 22.1052 24.5203H8.38586C7.83358 24.5203 7.38586 24.0726 7.38586 23.5203Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9.40015V10.4416C1 12.3406 2.53951 13.8801 4.43859 13.8801V13.8801C6.33768 13.8801 7.87719 12.3406 7.87719 10.4416V9.40015",
    stroke: "current",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8772 9.40015V10.4416C7.8772 12.3406 9.41671 13.8801 11.3158 13.8801V13.8801C13.2149 13.8801 14.7544 12.3406 14.7544 10.4416V9.40015",
    stroke: "current",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2456 9.40015V10.4416C15.2456 12.3406 16.7851 13.8801 18.6842 13.8801V13.8801C20.5833 13.8801 22.1228 12.3406 22.1228 10.4416V9.40015",
    stroke: "current",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1228 9.40015V10.4416C22.1228 12.3406 23.6623 13.8801 25.5614 13.8801V13.8801C27.4605 13.8801 29 12.3406 29 10.4416V9.40015",
    stroke: "current",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11.08V9.59675C1 9.46683 1.02532 9.33815 1.07454 9.21791L4.18434 1.62116C4.33814 1.24544 4.70382 1 5.1098 1H23.9752C24.3465 1 24.6872 1.2057 24.8601 1.53425L28.8849 9.18134C28.9605 9.32495 29 9.4848 29 9.64709V11.08",
    stroke: "current",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9.40015H29",
    stroke: "current",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.ea8c44eface52dbd8f630963625ef48b.svg";
export { ForwardRef as ReactComponent };